// Import metro-runtime first to fix HMR issues in monorepos
import '@expo/metro-runtime';
import 'expo-router/entry';
